import { render, staticRenderFns } from "./ProgramDetailHeader.vue?vue&type=template&id=fad2667a&scoped=true&"
import script from "./ProgramDetailHeader.vue?vue&type=script&lang=js&"
export * from "./ProgramDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProgramDetailHeader.vue?vue&type=style&index=0&id=fad2667a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad2667a",
  null
  
)

export default component.exports